import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompatibleItemService {

  constructor(private http: HttpClient) { }

  postCompatibleItem(formData){
    return this.http.post(environment.apiBaseURI + '/CompatibleItem', formData)
  }

  putCompatibleItem(formData){
    return this.http.put(environment.apiBaseURI + '/CompatibleItem/' + formData.id, formData)
  }


  getCompatibleItemList(selectednomenclature, param){
    return this.http.post(environment.apiBaseURI + '/CompatibleItem/GetItemsFromNomenclature/' + selectednomenclature, param);
  }


  deleteCompatibleItem(id){
    return this.http.delete(environment.apiBaseURI + '/CompatibleItem/' + id);
  }

  getUniqueNomenclatures(){
    return this.http.get(environment.apiBaseURI + '/CompatibleItem/GetUniqueNomenclatures' );
  }
}
